export default __webpack_public_path__ + "static/diagram-182544734dafdcc8f551ced68c255f9a.svg";